'use strict';

/* Services */


// Demonstrate how to register services
// In this case it is a simple value service.
angular.module('myApp.services', []).
	factory('profileOverviews', function ($http) {
		var overviews = {
			async : function () {
				var promise = $http.get('./model/overviews.json')
								.then(function (data) {
									return data.data;
								});
				return promise;
			}
		};
		return overviews;
	}).
	factory('services', function ($http) {
		var promise = $http.get('./model/services.json');
		return promise;
	}).
	factory('resources', function ($http) {
		var promise = $http.get('./model/resources.json');
		return promise;
	}).
	factory('cases', function ($http) {
		var promise = $http.get('./model/studies.json');
		return promise;
	});
